/**
 * @ignore
 */
export abstract class PaginationResult<T = any> {
  abstract items?: T[];

  currentPage: number;

  nextPage: number;
}
